import { useMemo } from 'react';
import { EmploymentType, EmploymentNeed } from '../types';

export const employmentOptions: {
    value: EmploymentType;
    needs: EmploymentNeed;
}[] = [
    {
        value: 'FAST_ANSTALLD',
        needs: {
            applicantEmployer: true,
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
        },
    },
    {
        value: 'VIKARIAT',
        needs: {
            applicantEmployer: true,
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
            applicantEmploymentYearUntil: true,
            applicantEmploymentMonthUntil: true,
            employmentTypeQualifying: true,
        },
    },
    {
        value: 'EGEN_FORETAGARE',
        needs: {
            applicantEmployer: true,
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
        },
    },
    {
        value: 'PENSIONAR',
        needs: {
            applicantEmploymentYearFrom: true,
            applicantEmploymentMonthFrom: true,
        },
    },
    {
        value: 'ARBETSLOS',
        needs: {},
    },
];

export const useEmploymentFields = (type: EmploymentType | undefined) => {
    const active = useMemo(() => {
        if (!type) {
            return {};
        }
        const option = employmentOptions.find(o => o.value === type);
        return option?.needs ?? {};
    }, [type]);

    return { active, options: employmentOptions };
};
